function addToCartButton() {
	const btnAddToCardWrapper = document.querySelector(".product-form.modal .container_button_wish");
	const btnAddInner = btnAddToCardWrapper.querySelector("button.product-form__submit");
	const btnAddToCardMirror = btnAddInner.querySelector(".product-form__submit-wrapper");
    const modalVariantItems = document.querySelectorAll('.variants form');
	const productVariantItems = document.querySelectorAll('.product variant-radios fieldset.tallas input');


	let inputValue;
	productVariantItems.forEach(input => {
		if (input.checked) {
			inputValue = input.value
		}
	});

	btnAddToCardWrapper.setAttribute("data-variant-selected", inputValue);
	btnAddToCardMirror.classList.add("set-btn");

	btnAddToCardMirror.addEventListener("click", (event) => {
		event.stopPropagation();
		btnAddToCardMirror
			.closest(".product-form__submit")
			.classList.add("loading");
		btnAddToCardMirror
			.closest(".product-form__submit")
			.querySelector(".loading-overlay__spinner")
			.classList.remove("hidden");
		modalVariantItems.forEach((btn) => {
			const btnVariant = btn.querySelector('button');
			const btnValue = btnVariant.textContent;
			if (btnAddToCardWrapper.getAttribute('data-variant-selected') == btnValue) {
			  btnVariant.click();
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', addToCartButton);
window.addToCartButton = addToCartButton;
